// The company's areas form a tree (the org chart): each has an optional
// superior, parent_id. Shared by Administración > Áreas and Personas >
// Organigrama.

const orden = (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0) || a.name.localeCompare(b.name)

// { raices, hijos: Map(id -> [area]) }. An area whose superior is not in the
// list (e.g. inactive, so the org chart leaves it out) is shown at the top.
export function arbolAreas(areas) {
  const ids = new Set(areas.map(a => a.id))
  const hijos = new Map()
  const raices = []
  for (const a of areas) {
    if (a.parent_id != null && ids.has(a.parent_id) && a.parent_id !== a.id) {
      if (!hijos.has(a.parent_id)) hijos.set(a.parent_id, [])
      hijos.get(a.parent_id).push(a)
    } else {
      raices.push(a)
    }
  }
  raices.sort(orden)
  for (const l of hijos.values()) l.sort(orden)
  return { raices, hijos }
}

// Depth-first, in display order: [{ area, nivel }]. Guards against a cycle
// (the server refuses them, but a bad row shouldn't hang the page).
export function aplanarArbol(areas) {
  const { raices, hijos } = arbolAreas(areas)
  const out = []
  const vistos = new Set()
  const visitar = (a, nivel) => {
    if (vistos.has(a.id)) return
    vistos.add(a.id)
    out.push({ area: a, nivel })
    for (const h of hijos.get(a.id) || []) visitar(h, nivel + 1)
  }
  raices.forEach(a => visitar(a, 0))
  // Anything left (only in a cycle) still gets listed, at the top.
  for (const a of areas) if (!vistos.has(a.id)) visitar(a, 0)
  return out
}

// The ids of an area and every area below it.
export function descendientes(areas, id) {
  const { hijos } = arbolAreas(areas)
  const out = new Set([id])
  const pila = [id]
  while (pila.length) {
    for (const h of hijos.get(pila.pop()) || []) {
      if (!out.has(h.id)) { out.add(h.id); pila.push(h.id) }
    }
  }
  return out
}
